module.exports = __webpack_public_path__ + "70cacccb48927e340d17358407f34716.png";